"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../material/index");

var _index2 = require("../../../utils/index");

var _pagination_helpers = require("../pagination_helpers");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _numberedpagination_styles = _interopRequireDefault(require("./numberedpagination_styles"));

var _numberedpagination_definition = _interopRequireDefault(require("./numberedpagination_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : PAGINATION : NUMBERED ~~~~~~~~~~ ========== */


var NumberedPagination =
/*#__PURE__*/
function (_Component) {
  _inherits(NumberedPagination, _Component);

  function NumberedPagination(props) {
    var _this;

    _classCallCheck(this, NumberedPagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberedPagination).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updatePageNumberSequence", function (moveForward) {
      // create new array to replace one in state
      var newPageSequence = []; // loop the same amount as the pageNumAmount set by engineer

      for (var x = 1; x <= _this.pageNumAmount; x++) {
        newPageSequence = _this.state.pageSequence.map(function (page) {
          return moveForward ? page + _this.pageNumAmount : page - _this.pageNumAmount;
        });
      }

      _this.setState({
        pageSequence: newPageSequence
      }, function () {
        return _this.shouldWeDisableArrows();
      }); // set new page sequence and check if we should disable arrows

    });

    _defineProperty(_assertThisInitialized(_this), "skipToEnds", function (moveForward) {
      // create new array to replace one in state
      var newPageSequence = [];

      if (moveForward) {
        (function () {
          // Figure out the difference between the first page in the current pageSequence and the first page of the end page sequence, this will be the new add amount
          var addAmt = Math.floor(_this.props.totalPages / _this.pageNumAmount) * _this.pageNumAmount + 1 - _this.state.pageSequence[0];

          for (var x = 1; x <= _this.pageNumAmount; x++) {
            newPageSequence = _this.state.pageSequence.map(function (page) {
              return page + addAmt;
            });
          }
        })();
      } else {
        newPageSequence = Array.from(Array(_this.pageNumAmount)).map(function (e, i) {
          return i + 1;
        }); // set initial page sequence from 1 to whatever page num total we were passed
      }

      _this.setState({
        pageSequence: newPageSequence
      }, function () {
        return _this.shouldWeDisableArrows();
      }); // set new page sequence and check if we should disable arrows

    });

    _defineProperty(_assertThisInitialized(_this), "hasItems", function () {
      return _this.props.totalItems > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "showCurrent", function () {
      return _react.default.createElement("span", {
        className: "current"
      }, (0, _pagination_helpers.handleCurrentItems)(_this.props.currentIndex, _this.props.totalItems, _this.props.itemsPerPage), " of ");
    });

    _defineProperty(_assertThisInitialized(_this), "showTotal", function () {
      return _react.default.createElement("span", {
        className: "total"
      }, _this.props.totalItemsDisplay ? _this.props.totalItemsDisplay : _this.props.totalItems);
    });

    _defineProperty(_assertThisInitialized(_this), "showNumbers", function () {
      return _this.state.pageSequence.map(function (page, i) {
        return page > _this.props.totalPages ? null : _react.default.createElement("span", {
          className: "navblock pagenumber current-".concat(_this.props.currentPage === page),
          onClick: function onClick() {
            return _this.props.handlePage(page);
          }
        }, " ", page, " ");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePrevious", function () {
      return _this.updatePageNumberSequence(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleNext", function () {
      return _this.updatePageNumberSequence(true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFirst", function () {
      return _this.skipToEnds(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLast", function () {
      return _this.skipToEnds(true);
    });

    _defineProperty(_assertThisInitialized(_this), "shouldWeDisableArrows", function () {
      _this.setState({
        previousDisabled: _this.state.pageSequence[0] <= 1,
        nextDisabled: _this.state.pageSequence[_this.state.pageSequence.length - 1] >= _this.props.totalPages
      });
    });

    _this.pageNumAmount = _this.props.pageNumAmount ? _this.props.pageNumAmount : 5;
    _this.state = {
      previousDisabled: false,
      nextDisabled: false,
      pageSequence: Array.from(Array(_this.pageNumAmount)).map(function (e, i) {
        return i + 1;
      }) // set initial page sequence from 1 to whatever page num total we were passed

    };
    return _this;
  }

  _createClass(NumberedPagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.shouldWeDisableArrows();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // check to see if we've changed pages (triggered by the simplepagination arrows or the clicking of a page number)
      if (this.props.currentPage !== prevProps.currentPage) {
        // if the requested page is greater than the last page in the numbers, or less than the first page in the numbers
        if (this.props.currentPage > this.state.pageSequence[this.pageNumAmount - 1] || this.props.currentPage < this.state.pageSequence[0]) {
          // check if direction is forward then update the page sequence appropriately
          this.props.currentPage > prevProps.currentPage ? this.updatePageNumberSequence(true) : this.updatePageNumberSequence(false);
        }
      } // if we've search or filtered, then check if we need to disable arrows


      if (this.props.totalItems !== prevProps.totalItems) {
        this.shouldWeDisableArrows();
      }
    }
  }, {
    key: "render",
    value: function render() {
      // don't show at all if no items
      if (this.props.totalItems <= 0) return null;
      return _react.default.createElement("div", {
        className: "numberedpagination ".concat((0, _index2.generateClasses)(this.props), " ").concat(this.props.classes.numberedpagination)
      }, _react.default.createElement("span", {
        className: "status"
      }, _react.default.createElement("span", {
        className: "display"
      }, this.hasItems() ? this.showCurrent() : null, this.showTotal())), _react.default.createElement("div", {
        className: "navigation"
      }, this.props.firstLastButtons ? _react.default.createElement("span", {
        className: "navblock first disabled-".concat(this.state.previousDisabled),
        onClick: this.handleFirst
      }, _react.default.createElement(_index.Icon, {
        name: "angle-double-left"
      })) : null, _react.default.createElement("span", {
        className: "navblock previous disabled-".concat(this.state.previousDisabled),
        onClick: this.handlePrevious
      }, _react.default.createElement(_index.Icon, {
        name: "angle-left"
      }), " "), this.showNumbers(), _react.default.createElement("span", {
        className: "navblock next disabled-".concat(this.state.nextDisabled),
        onClick: this.handleNext
      }, _react.default.createElement(_index.Icon, {
        name: "angle-right"
      }), " "), this.props.firstLastButtons ? _react.default.createElement("span", {
        className: "navblock last disabled-".concat(this.state.nextDisabled),
        onClick: this.handleLast
      }, _react.default.createElement(_index.Icon, {
        name: "angle-double-right"
      })) : null));
    }
  }]);

  return NumberedPagination;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(NumberedPagination, _numberedpagination_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_numberedpagination_styles.default)(NumberedPagination);

exports.default = _default;